import { SagaIterator } from 'redux-saga';
import { ProjectSettingsKey } from 'src/modules/common/types/ProjectSettingsKey';
import { PROJECT_VIEW_SETTINGS } from 'src/modules/project-view/actions/ProjectViewActions';
import { getProjectDetails } from 'src/modules/project-view/selectors/getProjectDetails';
import { getProjectSettings } from 'src/modules/project-view/selectors/getProjectSettings';
import { put, select } from 'typed-redux-saga';

export function* hvacHideAccuracyWarningSaga(): SagaIterator<void> {
  const project = yield* select(getProjectDetails);
  const settings = yield* select(getProjectSettings);

  yield* put(PROJECT_VIEW_SETTINGS.trigger({
    ...settings,
    [ProjectSettingsKey.HVAC_RESULTS_ACCURACY_WARNING]: false,
  }, project.id));
}
